const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/newsletter/posts/$slug.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";

// The page renders inside the member AppShell for everyone: signed-in members
// get the full chrome (header + nav dock); logged-out visitors get the header
// with a "Log in" action (the nav dock is logged-in-only in the shell). The
// reader endpoint remains the source of truth for post visibility.
export const Route = createFileRoute("/newsletter/posts/$slug")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});